export const AUTHORIZED_RESOURCE = ['PRODUCT', 'SERVICE', 'NOT_SELLABLE_SERVICE', 'EDITORIAL', 'STORE', 'PRODUCT-BROWSING-NAV', 'PRODUCT-LIST-NAV'];
export var RESOURCE_ENUMS;
(function (RESOURCE_ENUMS) {
  RESOURCE_ENUMS["RESOURCE_TYPE_SELECTOR"] = "jsonld_ResourceType";
})(RESOURCE_ENUMS || (RESOURCE_ENUMS = {}));